import { ClassicPreset, NodeEditor } from 'rete';
import { StateNode } from '../state-node/state-node';
import { Connection, Node, Schemes, WorkflowTransition } from '../types';
import { socket } from '../workflow-editor.component';

export class TransitionNode extends Node {
  width = 180;
  height = 80;
  from: StateNode[] = [];
  to?: StateNode;
  connections: Connection<Node>[] = [];

  constructor(
    public transition: WorkflowTransition,
    public editor: NodeEditor<Schemes>,
  ) {
    super(transition.id);

    this.width = transition.label.length * 8;

    if (transition.from_process_states) {
      this.addInput('from', new ClassicPreset.Input(socket, 'from', true));
      for (const stateId of transition.from_process_states) {
        const state = editor.getNodes().find(n => n.label === stateId) as StateNode | undefined;
        if (state) {
          this.from.push(state);
        }
      }
    }

    const state = editor.getNodes().find(n => n.label === transition.to_process_state) as StateNode | undefined;
    if (state) {
      this.to = state;
      this.addOutput('to', new ClassicPreset.Output(socket, 'to', false));
    }
  }

  async setupConnections(): Promise<void> {
    this.connections = [];
    await Promise.allSettled(this.from.map(async fromState => {
      const connection = new Connection<Node>(
        fromState,
        `out`,
        this,
        `from`,
      );

      try {
        await this.editor.addConnection(connection);
        this.connections.push(connection);
      } catch (error) {
        console.warn('Error while adding connection', error);
      }
    }));

    if (this.to) {
      const connection = new Connection<Node>(
        this,
        `to`,
        this.to,
        `in`,
      );

      try {
        await this.editor.addConnection(connection);
        this.connections.push(connection);
      } catch (error) {
        console.warn('Error while adding connection', error);
      }
    }
  }
}